import { css } from 'styled-components';
export const base = () => css(["display:flex;gap:.25rem;"]);
export const option = () => css(["flex-basis:3.125rem;width:3.125rem;flex-shrink:0;"]);
//# sourceMappingURL=YesOrNotButtons.style.js.map